import React from "react";

//MUI Imports
import { useTheme } from "@mui/material/styles";

//Project Imports

import { Divider, Grid, Stack, Typography } from "@mui/material";

import { useSelector } from "react-redux";
import LetterHead from "../../../ui-component/LetterHead";

const InterviewLetterPrint = React.forwardRef((props, ref) => {
  //Constants
  const theme = useTheme();
  const { jobPost, candidates, selectedJobApplicationId } = props;
  const { role } = useSelector((state) => state.userReducer);

  // //States
  console.log("selectedJobApplicationId", selectedJobApplicationId);
  // //Methods
  const selectedJobApplication = jobPost?.jobApplications?.find(
    (app) => app.id === selectedJobApplicationId
  );

  // // Find the candidate for this application
  const selectedCandidate = selectedJobApplication
    ? candidates?.find((c) => c.id === selectedJobApplication?.candidateId)
    : null;

  // // Get the interview details for this job application
  const interview = selectedJobApplication
    ? jobPost?.interviews?.find((interview) =>
        interview.jobApplicationInterviews?.some(
          (jai) => jai?.jobApplicationId === selectedJobApplication?.id
        )
      )
    : null;

  const getPageMargins = () => {
    return `@page { margin: ${"40px"} ${"30px"} ${"30px"} ${"30px"} !important; }`;
  };

  return (
    <div style={{ display: "none" }}>
      <div ref={ref}>
        <style>{getPageMargins()}</style>
        <div style={{ position: "fixed", top: "0", width: "100%" }}>
          <LetterHead />
        </div>
        <table style={{ width: "100%" }}>
          <thead>
            <tr>
              <td>
                <div style={{ height: "140px" }}></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div>
                  <div>
                    <Grid container spacing={2}>
                      <Grid item xs={12} align="center" sx={{ mb: 2 }}>
                        <Typography variant="h4">
                          INTERVIEW CALL LETTER
                        </Typography>
                      </Grid>
                    </Grid>
                    {selectedCandidate && (
                      <Grid
                        container
                        direction="row"
                        sx={{ paddingX: 1, mt: 3 }}
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2 }}>
                            Candidate Details:
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Name
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {selectedCandidate.salutation}{" "}
                            {selectedCandidate.firstName}{" "}
                            {selectedCandidate.middleName}{" "}
                            {selectedCandidate.lastName}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Address
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {selectedCandidate.addressLine1},{" "}
                            {selectedCandidate.addressLine2},
                            {selectedCandidate.city},{" "}
                            {selectedCandidate.district},
                            {selectedCandidate.state} -{" "}
                            {selectedCandidate.pinCode}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Mobile No.
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {selectedCandidate.phoneNumber || "--"}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Email
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {selectedCandidate.email || "--"}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                    {jobPost && (
                      <Grid
                        container
                        direction="row"
                        sx={{ paddingX: 1, mt: 3 }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2 }}>
                            Job Details:
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Employer Name
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.employerName}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Employer Address:
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.employerAddress}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Contact Person:
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.employerContactPerson}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Mobile No.:
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.employerMobileNo}
                          </Typography>
                        </Grid>
                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Job Title
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.title}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Qualification
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.qualification}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Experience
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.minExprienceRequired} -{" "}
                            {jobPost.maxExprienceRequired} years
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Salary Range
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : ₹{jobPost.minSalary} - ₹{jobPost.maxSalary} per
                            month
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Job Location
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {jobPost.location}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                    {interview && (
                      <Grid
                        container
                        direction="row"
                        sx={{ paddingX: 1, mt: 3 }}
                      >
                        <Grid item xs={12}>
                          <Typography variant="h5" sx={{ mb: 2 }}>
                            Interview Details:
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Date & Time
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            :{" "}
                            {interview.dateTime
                              ? new Date(interview.dateTime).toLocaleString()
                              : "--"}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Venue
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {interview.venue || "--"}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Interview Type
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {interview.typeDisplay || "--"}
                          </Typography>
                        </Grid>

                        <Grid item xs={3} sm={3} align="left">
                          <Typography variant="h5" sx={{ mb: "3px" }}>
                            Instructions
                          </Typography>
                        </Grid>
                        <Grid item xs={9} sm={9} align="left">
                          <Typography sx={{ mb: "3px" }}>
                            : {interview.description || "--"}
                          </Typography>
                        </Grid>
                      </Grid>
                    )}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
});

export default InterviewLetterPrint;
